import React, { useEffect, useRef, useState } from "react";
import styles from './Gallery.module.css';
import { imgArray2 } from "./ImgArray";
import GalleryElement from "./GalleryElement";
import TagContainer from "./TagContainer";
import { capitalizeFirstLetter } from "../../functions/Functions";
import GalleryElement2 from "./GalleryElement2";
import { useLocation } from "react-router-dom";
import ImageViewer2 from "./ImageViewer";

export default function GallerySelection(){

    const location = useLocation();

    const galleryRef = useRef(null);

    const [openImageViewer,setOpenImageViewer] = useState(false);

    const [tag,setTag] = useState(location.pathname.replace('/gallery/',''));

    const [imageHeight,setImageHeight] = useState(0);

    const [distinctTags,setDistinctTags] = useState([]);

    useEffect(() => {
        console.log('refresh');
        // setTagImgs([]);
        const newTag = location.pathname.replace('/gallery/','').split('?')[0];
        setTag((prev) => {
            if(prev !== newTag){
                setTagImgs([]);
            }
            return newTag;
        });
    },[location])

    useEffect(() => {  
        setDistinctTags(() => {
            let newArray = ['all'];
            imgArray2.forEach((imgObj) => {
                imgObj.tags.forEach((tag) => {
                    const index = newArray.findIndex((ele) => ele === tag);
                    if(index === -1){
                        newArray.push(tag);
                    }
                });
            });
            // const currentIndex = newArray.findIndex((ele) => ele === tag);
            // if (currentIndex > -1) { // only splice array when item is found
            //     newArray.splice(currentIndex, 1); // 2nd parameter means remove one item only
            // }
            return newArray;
        });        
    },[imgArray2,tag]);

    const [tagImgs,setTagImgs] = useState([]);

    useEffect(() => {
        setTagImgs(() => {
            if(tag === 'all'){
                return imgArray2;
            } else {
                return imgArray2.filter((imgObj) => imgObj.tags.some((arrTag) => arrTag === tag));
            }
        });
    },[imgArray2,tag]);

    const getImageWidth = () => {
        if(galleryRef){
            let noGaps;
            let gapWidth;
            if(window.innerWidth > 1600){
                noGaps = 5;
                gapWidth = 0.125*16;
            } else if (window.innerWidth <= 1600 && window.innerWidth > 1200){
                noGaps = 4;
                gapWidth = 0.125*16;
            } else if (window.innerWidth <= 1200 && window.innerWidth > 1000){
                noGaps = 3;
                gapWidth = 0.125*16;
            } else if (window.innerWidth <= 1000){
                noGaps = 2;
                gapWidth = 0.125*16;
            }
            const galleryWidth = galleryRef.current.getBoundingClientRect().width;
            setImageHeight((1.5*(galleryWidth-(noGaps*gapWidth)))/(noGaps+1))
        }
    }

    useEffect(() => {
        getImageWidth();
        window.addEventListener('resize',getImageWidth);
        return () => {
            window.removeEventListener('resize',getImageWidth);
        }
    },[]);

    return (
        <main>
            <ImageViewer2 open={openImageViewer} setOpen={setOpenImageViewer} tag={tag} tagImgs={tagImgs} />
            <section className={styles.top}>
                <h1>Gallery</h1><h2>{capitalizeFirstLetter(tag)}</h2>
            </section>
            <div className={styles.tagContainerSmall}>
                {distinctTags.map((tag) => <TagContainer tag={tag} imgArray={imgArray2} small={true}/>)}
            </div>
            <div ref={galleryRef} className={styles.galleryGrid} style={{gridAutoRows: `${imageHeight !== 0? imageHeight+'px' : '40vh'}`}}>
                {tagImgs.map((obj) => <GalleryElement2 imgObject={obj} tag={tag}/>)}
            </div>
        </main>
    )
}